import { DEFAULT_APP_TITLE } from '@/config/constants'
import Layout from '@/layout/index.vue'
import Login from '@/views/login/index.vue'
import Dashboard from '@/views/dashboard/index.vue'
import Daikuan from '@/views/daikuan/index.vue'
import DaikuanRecycle from '@/views/daikuan/recycle.vue'
import LoanOrdersSnap from '@/views/loanOrders/index.vue'
import BillsPage from '@/views/bills/index.vue'
import PayOrdersPage from '@/views/payOrders/index.vue'
import InvitationsPage from '@/views/invitations/index.vue'
import SystemSettings from '@/views/system/settings.vue'
import ContractTemplateSettings from '@/views/system/contract-template.vue'
import AdminsPage from '@/views/admins/index.vue'
import ArticlesPage from '@/views/articles/index.vue'
import AgreementEditorPage from '@/views/content/agreement-editor.vue'
import CustomersPage from '@/views/customers/index.vue'
import RepayPage from '@/views/repay/index.vue'
import type { RouteRecordRaw } from 'vue-router'

export const STATIC_ROUTES: RouteRecordRaw[] = [
  { path: '/login', component: Login, meta: { title: '登录' } },
  {
    path: '/',
    redirect: '/home',
    component: Layout,
    meta: {},
    children: [
      {
        path: 'home',
        component: Dashboard,
        meta: { title: `控制台 · ${DEFAULT_APP_TITLE}`, icon: 'Odometer' },
      },
      {
        path: 'loan/daikuan',
        component: Daikuan,
        meta: { title: '信贷订单', icon: 'List' },
      },
      {
        path: 'loan/daikuan-recycle',
        component: DaikuanRecycle,
        meta: { title: '订单回收站', icon: 'Delete' },
      },
      {
        path: 'loan/repay',
        component: RepayPage,
        meta: { title: '还款明细', icon: 'Wallet' },
      },
      {
        path: 'loan/orders-flat',
        component: LoanOrdersSnap,
        meta: { title: '订单快照', icon: 'Grid' },
      },
      {
        path: 'finance/bills',
        component: BillsPage,
        meta: { title: '账单', icon: 'Notebook' },
      },
      {
        path: 'finance/payorders',
        component: PayOrdersPage,
        meta: { title: '提现列表', icon: 'CreditCard' },
      },
      {
        path: 'ops/invitations',
        component: InvitationsPage,
        meta: { title: '邀请码结算', icon: 'UserFilled' },
      },
      {
        path: 'content/articles',
        component: ArticlesPage,
        meta: { title: '文章', icon: 'Document' },
      },
      {
        path: 'content/user-service-agreement',
        component: AgreementEditorPage,
        props: {
          agreementId: 1,
          pageTitle: '用户服务协议',
          hint: 'Admin/Fuwuxieyi/index',
          contentLabel: '用户服务协议内容',
        },
        meta: { title: '用户服务协议', icon: 'Reading' },
      },
      {
        path: 'content/loan-agreement',
        component: AgreementEditorPage,
        props: {
          agreementId: 2,
          pageTitle: '贷款协议',
          hint: 'Admin/Fuwuxieyi/jiekuanxieyi',
          contentLabel: '贷款协议内容',
        },
        meta: { title: '贷款协议', icon: 'Memo' },
      },
      {
        path: 'system/contract-template',
        component: ContractTemplateSettings,
        meta: { title: '合同模板', icon: 'DocumentCopy' },
      },
      {
        path: 'system/settings',
        component: SystemSettings,
        meta: { title: '系统设置', icon: 'Setting' },
      },
      {
        path: 'access/customers',
        component: CustomersPage,
        meta: { title: '用户管理', icon: 'Cellphone' },
      },
      {
        path: 'access/admins',
        component: AdminsPage,
        meta: { title: '管理员', icon: 'User' },
      },
    ],
  },
]
